/**
 * Registered company details, quoted by the legal pages. Previously duplicated
 * across the privacy, terms and security components — change it here only.
 *
 * The footer (`components/layout/footer.tsx`) still carries its own copy of the
 * address string.
 */
export const COMPANY = {
	name: "MangoMap Limited",
	/** Companies House registration. */
	number: "08388830",
	addressLines: ["1 Victoria Street", "Bristol, BS1 6AA", "United Kingdom"],
	supportEmail: "support@mangomap.com",
	securityEmail: "security@mangomap.com",
} as const;
